import { render } from "./ShopMenu.vue?vue&type=template&id=0d603244&scoped=true"
import script from "./ShopMenu.vue?vue&type=script&lang=js"
export * from "./ShopMenu.vue?vue&type=script&lang=js"

import "./ShopMenu.vue?vue&type=style&index=0&id=0d603244&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d603244"]])

export default __exports__